<app-dashboard-header active="welcome" />

<div class="flex-dashboard" [class.single-column]="layoutMode() === 'single-column'">
  @if (layoutMode() === 'single-column') {
    <div class="dashboard-column">
      @for (widget of singleColumnWidgets(); track trackByWidgetId($index, widget)) {
        <div
          class="widget-shell"
          [class.auto]="widget.heightMode === 'auto'"
          [class.fixed]="widget.heightMode === 'fixed'"
          [class.fill]="widget.heightMode === 'fill'"
          [style.height.px]="widget.heightMode === 'fixed' ? widget.heightPx : null"
          [style.minHeight.px]="widget.minHeightPx ?? 140"
        >
          <app-widget
            class="widget-host"
            [ngClass]="{ 'p-card p-component': true }"
            styleClass="rounded-2xl shadow-sm border border-surface-200 h-full"
            [data]="widget.data"
            [isEditable]="false">
          </app-widget>
        </div>
      }
    </div>
  } @else {
    <div class="dashboard-column">
      @for (widget of leftColumnWidgets(); track trackByWidgetId($index, widget)) {
        <div
          class="widget-shell"
          [class.auto]="widget.heightMode === 'auto'"
          [class.fixed]="widget.heightMode === 'fixed'"
          [class.fill]="widget.heightMode === 'fill'"
          [style.height.px]="widget.heightMode === 'fixed' ? widget.heightPx : null"
          [style.minHeight.px]="widget.minHeightPx ?? 140"
        >
          <app-widget
            class="widget-host"
            [ngClass]="{ 'p-card p-component': true }"
            styleClass="rounded-2xl shadow-sm border border-surface-200 h-full"
            [data]="widget.data"
            [isEditable]="false">
          </app-widget>
        </div>
      }
    </div>

    <div class="dashboard-column">
      @for (widget of rightColumnWidgets(); track trackByWidgetId($index, widget)) {
        <div
          class="widget-shell"
          [class.auto]="widget.heightMode === 'auto'"
          [class.fixed]="widget.heightMode === 'fixed'"
          [class.fill]="widget.heightMode === 'fill'"
          [style.height.px]="widget.heightMode === 'fixed' ? widget.heightPx : null"
          [style.minHeight.px]="widget.minHeightPx ?? 140"
        >
          <app-widget
            class="widget-host"
            [ngClass]="{ 'p-card p-component': true }"
            styleClass="rounded-2xl shadow-sm border border-surface-200 h-full"
            [data]="widget.data"
            [isEditable]="false">
          </app-widget>
        </div>
      }
    </div>
  }
</div>
